<div class="chevron-horizontal-body" [ngClass]="{'chevron-horizontal-highlight': highlight}" [style]="'min-width: ' + minWidth">
  <svg class="chevron-horizontal-tail" viewBox="0 0 20 10" preserveAspectRatio="none">
    <path d="
          M 20  0
          H  2
          L 18  5
          L  2 10
          H 20
          " stroke-width="1" />
  </svg>
  <svg class="chevron-horizontal-middle" viewBox="0 0 10 10" preserveAspectRatio="none">
    <rect width="10" height="10" stroke-width="0" />
    <path d="
          M  0  0
          H 10
          " stroke-width="1" />
    <path d="
          M  0 10
          H 10
          " stroke-width="1" />
  </svg>
  <svg class="chevron-horizontal-head" viewBox="0 0 20 10" preserveAspectRatio="none">
    <path d="
          M  0  0
          L 18  5
          L  0 10
          " stroke-width="1" />
  </svg>
  <div class="chevron-horizontal-label" [style]="'font-size: ' + fontSize" innerHTML="{{label}}"></div>
</div>
